import makeStyles from '@mui/styles/makeStyles'

export const useStyles = makeStyles(({ breakpoints, spacing, palette }) => ({
  toolbar: {
    '& > *': {
      paddingRight: 0
    }
  },
  creatorsContainer: {
    flex: '1 1 0',
    overflow: 'hidden'
  },
  creatorsGrid: {
    display: 'flex',
    flexDirection: 'column',
    gap: spacing(0.5)
  },
  contentGrid: {
    display: 'grid',
    gridTemplateAreas: `
        "breadcrumbs breadcrumbs breadcrumbs"
        "leftPanel content rightPanel"
      `,
    gridTemplateColumns: '1fr 660px 1fr',
    paddingTop: spacing(1),
    marginTop: spacing(2),

    [breakpoints.down('sm')]: {
      gridTemplateColumns: 'initial'
    }
  },
  contentMetadata: {
    marginBottom: spacing(1),
    fontSize: '0.75rem',
    color: '#79848B',
    '& svg': {
      width: 16,
      height: 16,
      verticalAlign: 'sub',
      marginRight: 4
    }
  },
  title: {
    marginBottom: spacing(2)
  },
  subtitle: {
    marginBottom: spacing(2),
    fontSize: '0.9rem'
  },
  header: {
    marginBottom: spacing(1)
  },
  verticalToolbar: ({ width }) => ({
    position: 'fixed',
    top: 114,
    left: 'calc(100vw / 2 - 660px / 2 - 166px)'
  }),
  playlistButton: {
    color: 'white',
    display: 'none',
    [breakpoints.up('lg')]: {
      display: 'initial'
    }
  },
  markAsViewedButton: {
    '&:disabled': {
      backgroundColor: palette.success.shade[10],
      color: palette.success.shade[80]
    }
  },
  relatedArticlesGrid: {
    width: '90%',
    paddingTop: spacing(4),
    height: 0
  }
}))
